// Minimal client-side store placeholder. Real Dexie-backed store lands in Phase 2;
// Phase 1 just provides a hook surface for ephemeral session state (e.g. banner dismissals).
import { useSyncExternalStore } from "react"

interface State {
  emailVerificationBannerDismissed: boolean
}

export class Store {
  #state: State = { emailVerificationBannerDismissed: false }
  #listeners = new Set<() => void>()

  use<T>(selector: (s: State) => T): T {
    // biome-ignore lint/correctness/useHookAtTopLevel: class-method-exposed hook intended for use inside React components (D-25..D-38 App composition root pattern)
    return useSyncExternalStore(
      (cb) => {
        this.#listeners.add(cb)
        return () => {
          this.#listeners.delete(cb)
        }
      },
      () => selector(this.#state),
      () => selector(this.#state),
    )
  }

  set(patch: Partial<State>): void {
    this.#state = { ...this.#state, ...patch }
    for (const cb of this.#listeners) cb()
  }
}
